import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { useStore } from '../context/StoreContext';

const SubscriptionModal = ({ isOpen, onClose }) => {
  const { subscribeUser } = useStore();

  if (!isOpen) return null;

  const handleSubscribe = () => {
    subscribeUser();
    onClose();
  };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          className="bg-dark-surface border border-dark-border rounded-2xl w-full max-w-4xl overflow-hidden relative"
        >
          <button onClick={onClose} className="absolute top-4 right-4 text-muted hover:text-white z-10">
            <SafeIcon name="X" className="w-6 h-6" />
          </button>
          
          <div className="p-8 md:p-12 text-center">
            <h2 className="text-3xl font-bold mb-4">Unlock Premium Access</h2>
            <p className="text-muted mb-8 max-w-xl mx-auto">Get instant access to all pro strategies, live trading sessions, and our exclusive community.</p>
            
            <div className="grid md:grid-cols-3 gap-6">
              {/* Free Trial */}
              <div className="bg-dark-card border border-dark-border rounded-xl p-6 text-left">
                <h3 className="text-xl font-semibold mb-2">7-Day Trial</h3>
                <div className="text-3xl font-bold mb-6">$0<span className="text-sm text-muted font-normal">/first week</span></div>
                <ul className="space-y-3 mb-8 text-sm text-muted">
                  <li className="flex items-center"><SafeIcon name="Check" className="text-rocket mr-2" /> Basic strategies</li>
                  <li className="flex items-center"><SafeIcon name="Check" className="text-rocket mr-2" /> 1 Live session</li>
                </ul>
                <button onClick={handleSubscribe} className="w-full py-3 rounded-lg border border-rocket text-rocket hover:bg-rocket hover:text-white transition-colors font-semibold">Start Trial</button>
              </div>

              {/* Pro Monthly */}
              <div className="bg-gradient-to-b from-rocket/20 to-dark-card border border-rocket rounded-xl p-6 text-left relative transform md:-translate-y-4 shadow-[0_0_30px_rgba(255,106,0,0.15)]">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-rocket text-white text-xs font-bold px-3 py-1 rounded-full">MOST POPULAR</div>
                <h3 className="text-xl font-semibold mb-2">Pro Monthly</h3>
                <div className="text-3xl font-bold mb-6">$49<span className="text-sm text-muted font-normal">/mo</span></div>
                <ul className="space-y-3 mb-8 text-sm text-muted">
                  <li className="flex items-center"><SafeIcon name="Check" className="text-rocket mr-2" /> All premium videos</li>
                  <li className="flex items-center"><SafeIcon name="Check" className="text-rocket mr-2" /> Daily live sessions</li>
                  <li className="flex items-center"><SafeIcon name="Check" className="text-rocket mr-2" /> Discord access</li>
                </ul>
                <button onClick={handleSubscribe} className="w-full py-3 rounded-lg bg-rocket hover:bg-rocket-hover text-white transition-colors font-semibold shadow-lg shadow-rocket/20">Subscribe Now</button>
              </div>

              {/* Pro Annual */}
              <div className="bg-dark-card border border-dark-border rounded-xl p-6 text-left">
                <h3 className="text-xl font-semibold mb-2">Pro Annual</h3>
                <div className="text-3xl font-bold mb-6">$399<span className="text-sm text-muted font-normal">/year</span></div>
                <ul className="space-y-3 mb-8 text-sm text-muted">
                  <li className="flex items-center"><SafeIcon name="Check" className="text-rocket mr-2" /> Everything in Monthly</li>
                  <li className="flex items-center"><SafeIcon name="Check" className="text-rocket mr-2" /> 2 Months Free</li>
                  <li className="flex items-center"><SafeIcon name="Check" className="text-rocket mr-2" /> 1-on-1 Coaching call</li>
                </ul>
                <button onClick={handleSubscribe} className="w-full py-3 rounded-lg border border-rocket text-rocket hover:bg-rocket hover:text-white transition-colors font-semibold">Save 30%</button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default SubscriptionModal;